import { render, staticRenderFns } from "./Brad.vue?vue&type=template&id=50e240fb&scoped=true&"
import script from "./Brad.vue?vue&type=script&lang=js&"
export * from "./Brad.vue?vue&type=script&lang=js&"
import style0 from "./Brad.vue?vue&type=style&index=0&id=50e240fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e240fb",
  null
  
)

export default component.exports